import { IAplosApiRequestArgs } from "@/services/aplosApi";

export interface GetFileDownloadUrlArgsOptions {
    tenantId: string;
    userId: string;
    fileId: string;
}

export class GetFileDownloadUrlArgs implements IAplosApiRequestArgs {

    public tenantId: string;
    public userId: string;
    public fileId: string;

    constructor(options: GetFileDownloadUrlArgsOptions) {
        if (options.tenantId == null) throw Error("tenantId is required");
        if (options.userId == null) throw Error("userId is required");
        if (options.fileId == null) throw Error("fileId is required");

        this.tenantId = options.tenantId;
        this.userId = options.userId;
        this.fileId = options.fileId;
    }

}